
import Vue from 'vue';
import Component from 'vue-class-component';
import Dropzone, { FileStructure } from '../../decorators/Dropzone';
import api from '../../service/api';
import { getModule } from 'vuex-module-decorators';
import store from '../../store';
import UserModule from '../../store/modules/User';

const userModule = getModule(UserModule, store);

@Component
@Dropzone
export default class LogoUploader extends Vue {
    public currentLogo: string|null = null;

    public triggerInput() {
        (this.$refs.fileInput as HTMLInputElement).click();
    }

    mounted() {
        this.$on('globalDragstart', () => this.$el.classList.add('logoDrop'));
        this.$on('globalDragend', () => this.$el.classList.remove('logoDrop'));
        this.$on('dragenter', () => this.$el.classList.add('logoDropActive'));
        this.$on('dragleave', () => this.$el.classList.remove('logoDropActive'));

        this.$on('drop', (structure: FileStructure) => {
            if (structure.allFiles.length === 1) {
                this.handleFile(structure.allFiles[0]);
            }
        });
        this.loadLogo();

        (this.$refs.fileInput as HTMLInputElement).addEventListener('change', (e) => {
            const fileList = (e.target as HTMLInputElement).files;
            if (fileList && fileList.length > 0) {
                this.handleFile(fileList.item(0)!);
            }
        });
    }

    async loadLogo() {
        this.currentLogo = await api.loadLogo(userModule.user!.id);
    }

    private async handleFile(file: File) {
        await api.uploadLogo(file);
        (this as any).$vToastify.success({
            title: 'Zaktualizowano',
            body: 'Twoje logo zostało ustawione',
        });
        this.loadLogo();
    }
}
